var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    stroke: "#5a0c25",
    fill: "none",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e84f7f",
    stroke: "none",
    transform: "translate(-10,-10)",
    d: "M73.8 139.715 60.932 100.11c5.542 8.148 10.38 14.17 14.597 18.04 2.856 2.621 5.548 4.37 8.093 5.043 2.642.698 5.07.214 7.138-1.477 1.981-1.619 3.528-4.256 4.773-7.668 1.255-3.436 2.26-7.815 3.06-13.09.59-3.9 1.074-8.32 1.46-13.252.507 5.305 1.102 10.038 1.798 14.192.902 5.381 1.982 9.84 3.285 13.331 1.292 3.464 2.859 6.132 4.832 7.759 2.068 1.705 4.483 2.179 7.094 1.416 2.5-.731 5.113-2.571 7.86-5.297 3.836-3.806 8.18-9.592 13.104-17.338l-12.329 37.946H73.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8 139.715 60.932 100.11c5.542 8.148 10.38 14.17 14.597 18.04 2.856 2.621 5.548 4.37 8.093 5.043 2.642.698 5.07.214 7.138-1.477 1.981-1.619 3.528-4.256 4.773-7.668 1.255-3.436 2.26-7.815 3.06-13.09.59-3.9 1.074-8.32 1.46-13.252.507 5.305 1.102 10.038 1.798 14.192.902 5.381 1.982 9.84 3.285 13.331 1.292 3.464 2.859 6.132 4.832 7.759 2.068 1.705 4.483 2.179 7.094 1.416 2.5-.731 5.113-2.571 7.86-5.297 3.836-3.806 8.18-9.592 13.104-17.338l-12.329 37.946H73.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.472642c6db8cf51476c92e08b01a1b02.svg";
export { ForwardRef as ReactComponent };